export default {
  stkPush: "paygate/mobile/v1/stk/pay",
  stkStatus: (ref) => `paygate/mobile/v1/stk/status/${ref}`,
  cheque: `paygate/cheque/v1/pay`,
  cardPayments: "paygate/card/flutterwave/payment",
  getBalance: (payload) => `paygate/balance?${buildQueryString(payload)}`,
  confirmPayment: 'paygate/confirmPayment',
  getPesaflowIframe: 'paygate/ecitizen/iframe',
};

function buildQueryString(params) {
  return Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
}
